import { ListItemButton, styled } from '@mui/material';

const ItemButton = styled(ListItemButton)`
  border: ${({ selected, theme }) => (selected ? `2px solid ${theme.palette.primary.main}` : 'none')};
  border-radius: 4px;
`;

export default ItemButton;
